import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { useParams } from 'react-router-dom';
import { useLazyQuery, useQuery } from 'react-apollo';
import { columnsProfissionaisSaude } from '../constants';
import List from '../../../components/list/list';
import ModalSlider from '../../../components/modal-slider/modal-slider';
import PagamentosProfissional from './pagamentos-profissional';
import InputSearch from '../../../components/input/Input';
import { FIND_PROFISSIONAIS_SAUDE_BY_VENDA_CSV, UTILIZA_API_PAGAMENTOS_ALTERNATIVO_POR_UNIDADE } from '../../../graphql/queryes';
import { IconButton } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import {possuiPermissao } from '../../../services/authority-service/can-criar-venda';
import { ROLE_PERMISSAO_EDITAR_PROFISSIONAL } from '../../../services/authority-service/enum';
import ConveniosAlternativo from './convenios-alternativo/ConveniosAlternativo';
import ModalDadosPagamentoAlternativoProfissional from './dados-pagamento-alternativo/ModalDadosPagamentoAlternativoProfissional';

const ProfissionaisSaude = ({
  pageableDTO,
  profissionais,
  findProfissionaisSaudeByVenda,
  handleEditProfissionalSaude,
  loadingProfissionaisSaudeVenda,
  withMarginTop,
  setPageableDTO,
  dadosDaVenda,
}) => {
  const entidadeAtual = JSON.parse(window.localStorage.getItem('entidadeAtual'));
  const params = useParams();
  const [profissionaisLoaded, setProfissionaisLoaded] = useState([]);
  const [isOpenPagamentoProfissionalModal, setIsOpenPagamentoProfissionalModal] = useState(false);
  const [profissionalSelecionado, setProfissionalSelecionado] = useState(null);
  const [isOpenPagamentoAlternativoModal, setIsOpenPagamentoAlternativoModal] = useState(false);
  const [profissionalAlternativoSelecionado, setProfissionalAlternativoSelecionado] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [typingTimeout, setTypingTimeout] = useState();
  const { content, last } = profissionais?.findProfissionaisSaudeByVenda || {};

  const unidadeId = dadosDaVenda?.unidade?.id;
  const { data: utilizaApiData } = useQuery(UTILIZA_API_PAGAMENTOS_ALTERNATIVO_POR_UNIDADE, {
    variables: { unidadeId },
    skip: !unidadeId,
  });
  const utilizaApiPagamentosAlternativo = utilizaApiData?.utilizaApiPagamentosAlternativoPorUnidade;

  const [downloadCsv, { data: downloadCsvData }] = useLazyQuery(FIND_PROFISSIONAIS_SAUDE_BY_VENDA_CSV);

  const handleLoadMore = () => {
    findProfissionaisSaudeByVenda({
      variables: {
        venda: {id: params.vendaId},
        pageableDTO: {
          ...pageableDTO,
          pageNumber: pageableDTO.pageNumber + 1,
        },
        search: searchText,
      },
    });
    setPageableDTO({
      ...pageableDTO,
      pageNumber: pageableDTO.pageNumber + 1,
    })
  };

  useEffect(() => {
    findProfissionaisSaudeByVenda({
      variables: {
        venda: {id: params.vendaId},
        pageableDTO,
      },
    });

    return () => {
      setProfissionaisLoaded([]);
      setPageableDTO({
        ...pageableDTO,
        pageNumber: 0
      });
    }
  }, []);

  useEffect(() => {
    const { pageNumber } = pageableDTO;
    const updatedProfissionais = pageNumber === 0 ? content : [...profissionaisLoaded, ...content || []];
    setProfissionaisLoaded(updatedProfissionais);
  }, [profissionais]);

  useEffect(() => {
    const base64Data = downloadCsvData?.findProfissionaisSaudeByVendaCsv;
    if (base64Data) {
      const url = `data:text/csv;base64,${base64Data}`;
      const link = document.createElement('a');
      link.href = url;
      link.download = `profissionais-saude-venda.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }, [downloadCsvData])

  const handleSearchTextChange = (e) => {
    const text = e.target.value;
    setSearchText(text);

    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    setTypingTimeout(setTimeout(() => {
      findProfissionaisSaudeByVenda({
      variables: {
        venda: {id: params.vendaId},
        pageableDTO: {
          ...pageableDTO,
          pageNumber: 0,
        },
        search: searchText,
      },
    });
    }, 500));
  };

  const handleDownloadCsv = async () => {
    try {
      downloadCsv({
        variables: {
          venda: {id: params.vendaId},
          search: searchText,
          pageableDTO: {
            sortDir: pageableDTO.sortDir,
            sortField: pageableDTO.sortField,
          }
        }
      });
    } catch (error) {
      console.error('Erro ao baixar CSV:', error);
    }
  };

  const handleOpenPagamentoAlternativo = (profissional) => {
    setProfissionalAlternativoSelecionado(profissional);
    setIsOpenPagamentoAlternativoModal(true);
  };

  const handleClosePagamentoAlternativo = () => {
    setIsOpenPagamentoAlternativoModal(false);
    setProfissionalAlternativoSelecionado(null);
  };

  const handleOpenPagamentoProfissional = (profissional) => {
    if (profissional.possuiPagamentoIndividualIA) {
      setProfissionalSelecionado(profissional);
      setIsOpenPagamentoProfissionalModal(true);
    } else {
      window.open(`/pagamento-ia-profissional?idProfissional=${profissional.id}`, '_blank');
    }
  };

  const handleClosePagamentoProfissional = () => {
    setIsOpenPagamentoProfissionalModal(false);
    setProfissionalSelecionado(null);
  };

  return (
    <Content withMarginTop={withMarginTop}>
      <HeaderContainer>
        <HeaderWithSearch>
          <Header> Profissionais de saúde </Header>
          <SearchInputStyled
            onChange={handleSearchTextChange}
            value={searchText}
            placeholder="Pesquisar profissional"
          />
        </HeaderWithSearch>
        <DownloadButton onClick={handleDownloadCsv} title="Baixar CSV">
          <GetAppIcon />
        </DownloadButton>
      </HeaderContainer>
      <ListProfissionais
        columns={columnsProfissionaisSaude({
          vendaId: params.vendaId,
          isVizi: entidadeAtual.whitelabel?.nome === "VIZI_SAUDE",
          handleOpenPagamentoProfissional,
          handleOpenPagamentoAlternativo,
        })}
        items={profissionaisLoaded || []}
        loading={loadingProfissionaisSaudeVenda}
        last={last}
        onClickItem={possuiPermissao(ROLE_PERMISSAO_EDITAR_PROFISSIONAL) && handleEditProfissionalSaude}
        onLoadMore={handleLoadMore}
      />

      {isOpenPagamentoProfissionalModal && (
        <ModalSlider
        isOpen={isOpenPagamentoProfissionalModal}
        onClose={handleClosePagamentoProfissional}
        title="Pagamentos da IA"
      >

          <PagamentosProfissional
          profissional={profissionalSelecionado}
          onClose={handleClosePagamentoProfissional}
          open={isOpenPagamentoProfissionalModal}
          />
      </ModalSlider>
      )}

      {isOpenPagamentoAlternativoModal && (
        <ModalSlider
          isOpen={isOpenPagamentoAlternativoModal}
          onClose={handleClosePagamentoAlternativo}
          title="Dados de Pagamento Alternativo"
        >
          <ModalDadosPagamentoAlternativoProfissional
            profissional={profissionalAlternativoSelecionado}
            onClose={handleClosePagamentoAlternativo}
            onSuccess={handleClosePagamentoAlternativo}
          />
        </ModalSlider>
      )}

      {utilizaApiPagamentosAlternativo && (
        <ConveniosAlternativo unidade={dadosDaVenda?.unidade} />
      )}
    </Content>
  );
};

export default ProfissionaisSaude;

const HeaderWithSearch = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const SearchInputStyled = styled(InputSearch)`
  background-color: white;
  border-radius: 4px;
  background-color: white !important;

  div {
    background-color: white !important;
    border-radius: 4px;
  }
`;

const DownloadButton = styled(IconButton)`
  background-color: #FBBF6D !important;
  color: white !important;

  &:hover {
    background-color: #F5B85A !important;
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${props => props.withMarginTop ? '24px' : '0'};
`;

const Header = styled.label`
  font-size: 18px;
  font-weight: 700;
  line-height: 27px;
`;

const ListProfissionais = styled(List)`
  overflow: auto;
  max-height: 800px;
`;
